(function () {
    'use strict';
    $(document).ready(function () {

        gsap.to(".subpage #blob-bg", {
            scrollTrigger: {
                trigger: "#cta-start",
                start: "top center",
                end: "+=500",
                scrub: true,
            },
            opacity: 0
        });

        gsap.set(".number", {
            opacity: 0,
        });
        ScrollTrigger.batch(".number", {
            onEnter: batch => gsap.to(batch, {
                opacity: 1,
                delay: .5,
                duration: .5,
                stagger: .25,
                onStart: function() {
                    if ($(batch).find('.value').length) {

                        $(batch).find('.value').each(function() {
                            const number = $(this);
                            if (!number.hasClass('counted')) {
                                let numberText = number.text();
                                number.empty();
                                number.shuffleLetters({
                                    "text": numberText,
                                    "fps": 16,
                                    "step": 16
                                })
                                number.addClass('counted');
                            }
                        });

                    }
                }
            }),
            start: "top 80%",
        });

        // Scroll image in list with image module
        if (window.matchMedia("(min-width: 768px)").matches) {
            ScrollTrigger.create({
                trigger: ".text-col",
                pin: ".list-with-image img",
                start: "top 240px",
                end: "bottom " + ($('.list-with-image img').height() + 240) + "px"
            });

            ScrollTrigger.create({
                trigger: ".job-description",
                pin: ".job-details-wrapper",
                start: "top 220px",
                end: "bottom " + ($('.job-details-wrapper').height() + 220) + "px"
            });
        }


        // SOCIAL SHARING
        var $share = $('#share');
        $share.jsSocials({
            showLabel: false,
            showCount: false,
            shareIn: "popup",
            text: document.title,
            url: window.location.href,
            shares: [
                {
                    share: "twitter",
                    logo: `${$share.attr('data-templateURL')}/dist/images/twitter.svg`,
                    inlineSvg: true,
                    via: "sensidsolutions",
                },
                {
                    share: "email",
                    logo: `${$share.attr('data-templateURL')}/dist/images/email.svg`,
                    inlineSvg: true,
                },
                {
                    share: "linkedin",
                    logo: `${$share.attr('data-templateURL')}/dist/images/linkedin.svg`,
                    inlineSvg: true,
                }
            ]
        });


        //tools show/hide
        $('#tools-toggle').click(function () {
            $('.tools-list').animate({
                height: 'toggle'
            });
            $(this).toggleClass('opened');
        });

        // accordion scroll animation
        $('.subpage .accordion.scroll-animation .collapse, .subpage .accordion .collapse').on('shown.bs.collapse', function (e) {
            updateTableSize();
            var positionTop = $(this).parent().offset().top; // - $('header').height();
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
            $(window).resize();
        });

        // responsive image enlarging
        $('.popup-trigger').click(function (e) {
            $(this).parent().find('.popup-image-container').fadeIn();
            e.preventDefault();
            return false;
        });

        $('.popup-image-container').click(function () {
            $(this).fadeOut();
        });

        //Tooltipster

        // default tooltips
        $('.default-tooltipster').tooltipster({
            maxWidth: 290,
            contentAsHTML: true,
            interactive: true,
            functionPosition: function (instance, helper, position) {
                position.coord.left = helper.geo.origin.offset.left - 20;
                return position;
            },
        });

        function updateTableSize() {
            $('.table-container').each(function () {
                if ($(this).parent().hasClass('panel-body')) return;
                var containerWidth = $(this).width();
                var tableWidth = $('table', this).width();

                if (tableWidth > containerWidth) {
                    $(this).addClass('scrollable');
                    $(this).mCustomScrollbar({
                        axis: "x",
                        mouseWheel: {
                            enable: true
                        }
                    });
                } else {
                    $(this).removeClass('scrollable');
                    $(this).mCustomScrollbar('destroy');
                }
            });
        }

    });
}(jQuery));
